<div class="flex-page">
  <div class="header">
    <h1>Sorry, something went wrong ...</h1>
  </div>
  <h2>
    Error 404: This page does not exist
  </h2>
</div>